/**
 * @fileoverview DELETE handler for the "/:app_group_id/operator_mcp_connections/:connection_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAppGroupIdOperatorMcpConnectionsConnectionIdCacheKeys } from "./constants";
import type {
  DeleteAppGroupIdOperatorMcpConnectionsConnectionIdProps,
  DeleteAppGroupIdOperatorMcpConnectionsConnectionIdResult,
} from "./types";

export const deleteAppGroupIdOperatorMcpConnectionsConnectionId = reactQueryMutationAdapter(
  deleteAppGroupIdOperatorMcpConnectionsConnectionIdCacheKeys,
  ({
    appGroupId,
    connectionId,
  }: DeleteAppGroupIdOperatorMcpConnectionsConnectionIdProps): Promise<DeleteAppGroupIdOperatorMcpConnectionsConnectionIdResult> => {
    return fetch(`/${appGroupId}/operator_mcp_connections/${connectionId}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
